import { Route, Routes, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import AuthScreen from "./Components/Layout/Auth/AuthScreen";
import ProviderList from "./Components/Layout/Auth/ProviderList";
import TenantList from "./Components/Layout/Auth/TenantList";
import TermsOfServices from "./Pages/Terms/TermsOfServices";
import PrivacyPolicy from "./Pages/Privacy/PrivacyPolicy";

function App() {
  const [profileObject, setProfileObject] = useState({});
  const [profileResponse, setProfileResponse] = useState({});
  const location = useLocation();

  useEffect(() => {
    const routeTitles = {
      "/": "Sign in – Health Frigate",
      "/providerList": "Choose a provider – Health Frigate",
      "/tenant-list": "Choose a hospital – Health Frigate",
    };

    const currentTitle = routeTitles[location.pathname] || "Health Frigate";
    document.title = currentTitle;
  }, [location]);

  return (
    <div className="App">
      <ToastContainer position="top-center" reverseOrder={false} />
      <Toaster position="top-center" reverseOrder={false} />
      <Routes>
        <Route
          path="/"
          element={
            <AuthScreen
              profileObject={profileObject}
              setProfileObject={setProfileObject}
              profileResponse={profileResponse}
              setProfileResponse={setProfileResponse}
            />
          }
        />
        <Route
          path="/providerlist"
          element={
            <ProviderList
              profileObject={profileObject}
              setProfileObject={setProfileObject}
            />
          }
        />

        <Route path="/tenant-list" element={<TenantList />} />

        <Route path="/privacy" element={<PrivacyPolicy />} />

        <Route path="/terms" element={<TermsOfServices />} />
      </Routes>
    </div>
  );
}

export default App;
